export function fetchUserLocation(): Promise<
  { latitude: number; longitude: number } | undefined
> {
  return new Promise((resolve, reject) => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          resolve({ latitude, longitude });
        },
        (error) => {
          console.log(`Error getting location: ${error.message}`);
          reject(undefined);
        }
      );
    } else {
      console.log("Geolocation is not available in your browser");
      reject(undefined);
    }
  });
}

export async function watchUserLocation(): Promise<
  { latitude: number; longitude: number } | undefined
> {
  if (!navigator.geolocation) {
    console.log("Geolocation is not supported by your browser");
    return;
  }

  return new Promise((resolve, reject) => {
    let watchId = navigator.geolocation.watchPosition(
      (position) => {
        // console.log(
        //   `Latitude: ${position.coords.latitude}, Longitude: ${position.coords.longitude}`
        // );
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => {
        console.error("Error Code = " + error.code + " - " + error.message);
        // reject(undefined);
      },
      {
        enableHighAccuracy: true,
        timeout: 30000, // 30 seconds
        maximumAge: 0,
      }
    );
  });
  // To stop watching the user's location after some time, you can use:
  // navigator.geolocation.clearWatch(watchId);
}
